import { render, staticRenderFns } from "./AddSecondProject-View.vue?vue&type=template&id=43531aa4&scoped=true&"
import script from "./AddSecondProject-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddSecondProject-View.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddSecondProject-View.vue?vue&type=style&index=0&id=43531aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43531aa4",
  null
  
)

export default component.exports